import React, { Component } from "react";
import axios from 'axios';
import Loading from "../../components/preloader/Loading";
import Header from "../../components/header/Header";
import httpClient from '../../services/HttpClient';
import Countdown from '../../services/Countdown';
import {
  Row,
  Col,
  Button
} from "reactstrap";
import "./DownloadPage.css";


class DownloadPage extends Component {
  state = {
    message: '',
    isLoading: true,
    linkExpired: false,
    expires: 0
  };

  async downloadFileInBrowser(url) {
    try {
      const response = await httpClient({
        method: 'get',
        url: url,
        responseType: 'blob', // Important: Get the file as a blob
      });
  
      // Create a URL for the blob and trigger a download
      const blobUrl = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', 'results.zip'); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
  
      console.log('File downloaded successfully');
    } catch (error) {
      console.error('Error downloading the file:', error.message);
    }
  };

  goHome = () => {
    window.location.href = "#/main";
  };

  getQueryParamFromHash = (key) => {
    const hash = window.location.hash; // Get the hash part of the URL
    const queryString = hash.split('?')[1]; // Extract the query string
    if (!queryString) return null;

    const params = new URLSearchParams(queryString);
    return params.get(key); // Get the specific parameter
  };

  getResultInfo = async() => {
    const apiBaseUrl = window.clipship_config.ApiBaseUrl;
    const uuid = this.getQueryParamFromHash('uuid'); 

    try {
      const response = await httpClient.get(`${apiBaseUrl}/result/${uuid}`);
      let message = (
        <>
        <div className="download-message">The results should have automatically downloaded, but in case they haven't you can click the following link: </div>
        <div className="download-message"><a href={response.data.download_url} target="_blank">Download Results</a></div>
        <div className="download-message" style={{fontSize: 12}}><Countdown expirationTime={response.data.expires} /></div>
        </>
      );

      const interval = setInterval(() => {
        const remainingTime = response.data.expires - Date.now();
        if (remainingTime <= 0) {
          clearInterval(interval); 
          this.setState({
            linkExpired: true
          });
        }
      }, 1000);

      this.setState({
        message: message,
        expires: response.data.expires,
        isLoading: false
      }, () => {
          window.open(response.data.download_url, "_blank");
      });
    } catch (error) {
      let message = (
        <div className="download-message">There was an issue downloading your results.  Please reload the page to try again and if the issue persists contact us.</div>
      );

      if ( !!error.response.data && !!error.response.data.error ) {
        message = (
          <>
            <div className="download-message">The request failed with the following message:</div>
            <div className="download-message" style={{fontSize: 18}}>{error.response.data.error}</div>
            <div className="download-message">If you are unsure on how to resolve this issue please contact us.</div>
          </>
        );
      }

      this.setState({
        message: message,
        isLoading: false
      });
    }
  };

  componentDidMount() {
    this.getResultInfo();
  };

  render() {
    const { message, isLoading, linkExpired, expires } = this.state;
    return (
      <>
        <Header />
        <Loading isOpen={isLoading} />
        {linkExpired && <div className="download-message">Download link expired.  Refresh the page to download the results again.</div>}
        {!linkExpired &&
          <>
            {message}
          </>
        }
        <div className="download-message">
          <Button className="btn btn-success rounded-pill" onClick={this.goHome}>Create New Request</Button>
        </div>
      </>
    );
  }
}


export default DownloadPage;
